<app-match-game class="slide-out" [ngStyle]="{'display': (routeService.previousUrl == '/match-game/mitanim' || routeService.previousUrl == '/match-game/nosaim') ? 'block' : 'none'}" id="matchGame"></app-match-game>
<app-trivia-game class="slide-out" [ngStyle]="{'display': (routeService.previousUrl == '/trivia-game/mitanim' || routeService.previousUrl == '/trivia-game/nosaim') ? 'block' : 'none'}" id="triviaGame"></app-trivia-game>
<app-choose-game class="slide-out" style="display: none;" id="chooseGameList"></app-choose-game>

<div class="page" [ngClass]="{'trivia': game.kind == 'trivia', 'match': game.kind == 'match'}">
  <!-- <app-header [game]="game" [board]="true"></app-header> -->
  <app-header [board]="true"></app-header>
  <div class="star">
    <h1>טבלת שיאים</h1>
    <div class="champions">
      <div class="place-container">
        <div class="circle" [ngClass]="{grey: game.kind == 'trivia', blue: game.kind == 'match'}">
          <h4>2</h4>
        </div>
        <h3>{{players[1].name}}</h3>
      </div>
      <div class="place-container">
        <div class="circle big" [ngClass]="{grey: game.kind == 'trivia', blue: game.kind == 'match'}">
          <img src="../../../assets/images/icons/award.png">
        </div>
        <h2>{{players[0].name}}</h2>
      </div>
      <div class="place-container">
        <div class="circle" [ngClass]="{grey: game.kind == 'trivia', blue: game.kind == 'match'}">
          <h4>3</h4>
        </div>
        <h3>{{players[2].name}}</h3>
      </div>
    </div>
    <div class="white">
      <div class="orange">
      </div>
      <div class="players">
        <div class="player-container" *ngFor="let player of players; let i = index" [ngClass]="{'first': i == 0}">
          <img *ngIf="i == 0" src="../../../assets/images/icons/medal.png">
          <h2 *ngIf="i != 0" class="place-number">{{i+1}}</h2>
          <h2 class="name">{{player.name}}</h2>
          <h4 class="score">{{player.score}}</h4>
        </div>
      </div>
      <!-- <table class="players">
        <tr class="player-container" *ngFor="let player of players; let i = index" [ngClass]="{'first': i == 0}">
          <td *ngIf="i == 0" src="../../../assets/images/icons/medal.png"></td>
          <td *ngIf="i != 0">{{i+1}}</td>
          <td>{{player.name}}</td>
          <td>{{player.score}}</td>
        </tr>
      </table> -->
      <div [ngClass]="{'match-footer': game.kind == 'match', 'trivia-footer': game.kind == 'trivia'}"></div>
    </div>
  </div>
</div>
